(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    var form = document.getElementById('cart-form');
    var submitTimer;

    function scheduleSubmit() {
      clearTimeout(submitTimer);
      submitTimer = setTimeout(function() { form.submit(); }, 400);
    }

    document.querySelectorAll('.cart__item').forEach(function(item) {
      var input = item.querySelector('.cart__qty-input');
      var minus = item.querySelector('.cart__qty-minus');
      var plus = item.querySelector('.cart__qty-plus');
      if (!input) return;

      minus.addEventListener('click', function() {
        var v = parseInt(input.value, 10);
        if (v > 1) {
          input.value = v - 1;
        } else {
          input.value = 0;
        }
        scheduleSubmit();
      });

      plus.addEventListener('click', function() {
        input.value = parseInt(input.value, 10) + 1;
        scheduleSubmit();
      });

      input.addEventListener('change', scheduleSubmit);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    var sidebar = document.getElementById('coll-sidebar');
    var overlay = document.getElementById('coll-overlay');
    var openBtn = document.getElementById('coll-filter-open');
    var closeBtn = document.getElementById('coll-sidebar-close');

    function openSidebar() {
      if (sidebar) sidebar.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeSidebar() {
      if (sidebar) sidebar.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    if (openBtn) openBtn.addEventListener('click', openSidebar);
    if (closeBtn) closeBtn.addEventListener('click', closeSidebar);
    if (overlay) overlay.addEventListener('click', closeSidebar);

    function applyRouteProductType() {
      var params = new URLSearchParams(window.location.search);
      var requestedType = params.get('sd_product_type');
      if (!requestedType) {
        var shopifyType = params.get('filter.p.product_type');
        if (shopifyType) requestedType = shopifyType;
      }
      if (!requestedType) return;

      requestedType = requestedType.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      if (requestedType !== 'darts') return;

      var cards = document.querySelectorAll('.product-card--collection[data-product-type]');
      var visibleCount = 0;

      cards.forEach(function(card) {
        var isMatch = card.getAttribute('data-product-type') === requestedType;
        card.classList.toggle('is-route-hidden', !isMatch);
        if (isMatch) visibleCount += 1;
      });

      var count = document.querySelector('.coll__count');
      if (count) count.textContent = visibleCount + ' ' + (visibleCount === 1 ? 'product' : 'products');
    }
    applyRouteProductType();

    document.querySelectorAll('.filter-group__btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var bodyId = btn.getAttribute('data-toggle');
        var body = document.getElementById(bodyId);
        if (!body) return;
        var open = body.classList.contains('is-open');
        body.classList.toggle('is-open', !open);
        btn.classList.toggle('is-open', !open);
        btn.setAttribute('aria-expanded', !open);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var accordions = document.querySelectorAll('.site-footer__accordion');
    if (!accordions.length) return;

    var desktop = window.matchMedia('(min-width: 961px)');

    function syncAccordions() {
      accordions.forEach(function (accordion) {
        if (desktop.matches) {
          accordion.setAttribute('open', '');
        } else {
          accordion.removeAttribute('open');
        }
      });
    }

    syncAccordions();
    desktop.addEventListener('change', syncAccordions);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var input = document.getElementById('header-search-input');
    if (!input) return;

    var wrap = input.closest('.header-search__input-wrap');
    var fake = wrap && wrap.querySelector('.header-search__fake');
    var termEl = fake && fake.querySelector('.header-search__fake-term');
    if (!fake || !termEl) return;

    var raw = input.dataset.searchTerms || 'darts, dartboards, flights, stems & shafts, dart cases, accessories';
    var terms = raw.split(',').map(function(t) { return t.trim(); }).filter(Boolean);
    if (!terms.length) terms = ['darts'];

    var termIndex = 0;
    var charIndex = 0;
    var isDeleting = false;
    var paused = false;
    var timer = null;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function clearTimer() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    }

    function shouldAnimate() {
      return !paused && !input.value && !fake.classList.contains('header-search__fake--hidden');
    }

    function resetTypewriter() {
      termIndex = 0;
      charIndex = 0;
      isDeleting = false;
      termEl.textContent = '';
    }

    function tick() {
      if (!shouldAnimate()) return;

      var term = terms[termIndex];

      if (!isDeleting) {
        charIndex++;
        termEl.textContent = term.slice(0, charIndex);

        if (charIndex >= term.length) {
          isDeleting = true;
          timer = setTimeout(tick, 2000);
          return;
        }

        timer = setTimeout(tick, 85);
        return;
      }

      charIndex--;
      termEl.textContent = term.slice(0, charIndex);

      if (charIndex <= 0) {
        isDeleting = false;
        termIndex = (termIndex + 1) % terms.length;
        timer = setTimeout(tick, 350);
        return;
      }

      timer = setTimeout(tick, 40);
    }

    function start() {
      clearTimer();

      if (reducedMotion) {
        termEl.textContent = terms[termIndex];
        timer = setTimeout(function cycleStatic() {
          if (!shouldAnimate()) return;
          termIndex = (termIndex + 1) % terms.length;
          termEl.textContent = terms[termIndex];
          timer = setTimeout(cycleStatic, 2500);
        }, 2500);
        return;
      }

      tick();
    }

    resetTypewriter();
    start();

    input.addEventListener('focus', function() {
      paused = true;
      clearTimer();
      fake.classList.add('header-search__fake--hidden');
    });

    input.addEventListener('blur', function() {
      if (!input.value) {
        fake.classList.remove('header-search__fake--hidden');
        paused = false;
        resetTypewriter();
        clearTimer();
        timer = setTimeout(start, 400);
      }
    });

    input.addEventListener('input', function() {
      var hasValue = input.value !== '';
      fake.classList.toggle('header-search__fake--hidden', hasValue);
      if (hasValue) {
        paused = true;
        clearTimer();
      } else if (document.activeElement !== input) {
        paused = false;
        resetTypewriter();
        clearTimer();
        timer = setTimeout(start, 400);
      }
    });
  })();

  // Hamburger toggle
  (function() {
    var toggle = document.getElementById('nav-toggle');
    var nav = document.getElementById('mobile-nav');
    var overlay = document.getElementById('mobile-nav-overlay');
    if (!toggle || !nav) return;

    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      toggle.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      nav.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('sd-nav-open', open);
      if (overlay) overlay.classList.toggle('is-open', open);
    }

    toggle.addEventListener('click', function() {
      setOpen(!nav.classList.contains('is-open'));
    });
    if (overlay) overlay.addEventListener('click', function() { setOpen(false); });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) setOpen(false);
    });
    nav.querySelectorAll('.mobile-nav__link:not(.mobile-nav__toggle)').forEach(function(link) {
      link.addEventListener('click', function() { setOpen(false); });
    });
  })();

  // Mobile sub-menu toggles
  [
    ['mobile-new-toggle', 'mobile-new-sub'],
    ['mobile-tj-toggle', 'mobile-tj-sub'],
    ['mobile-players-toggle', 'mobile-players-sub'],
    ['mobile-darts-toggle', 'mobile-darts-sub'],
    ['mobile-flights-toggle', 'mobile-flights-sub'],
    ['mobile-points-toggle', 'mobile-points-sub'],
    ['mobile-dbacc-toggle', 'mobile-dbacc-sub'],
    ['mobile-acc-toggle', 'mobile-acc-sub'],
    ['mobile-services-toggle', 'mobile-services-sub']
  ].forEach(function(pair) {
    var btn = document.getElementById(pair[0]);
    var sub = document.getElementById(pair[1]);
    if (!btn || !sub) return;
    btn.addEventListener('click', function() {
      var open = sub.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        document.querySelectorAll('.mobile-nav__sub.is-open').forEach(function(other) {
          if (other !== sub) {
            other.classList.remove('is-open');
            var otherBtn = other.previousElementSibling;
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var el = document.getElementById('hero-carousel');
    var track = document.getElementById('hero-track');
    if (!el || !track) return;

    var slides = Array.from(track.querySelectorAll('.hero__slide'));
    var controls = Array.from(el.querySelectorAll('.hero__control'));
    var total = slides.length;
    var current = 0;
    var speed = parseInt(el.dataset.speed, 10) || 5000;
    var timer = null;
    var progressTimer = null;
    var progressStart = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      controls[current] && controls[current].classList.remove('is-active');
      resetProgress(controls[current]);

      current = (index + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      slides[current].classList.add('is-active');
      controls[current] && controls[current].classList.add('is-active');
    }

    function resetProgress(ctrl) {
      if (!ctrl) return;
      var ring = ctrl.querySelector('.hero__control-progress');
      if (ring) ring.style.strokeDashoffset = '94.25';
      cancelAnimationFrame(progressTimer);
    }

    function animateProgress(ctrl) {
      if (!ctrl) return;
      var ring = ctrl.querySelector('.hero__control-progress');
      if (!ring) return;
      progressStart = performance.now();
      function step(now) {
        var elapsed = now - progressStart;
        var frac = Math.min(elapsed / speed, 1);
        ring.style.strokeDashoffset = 94.25 * (1 - frac);
        if (frac < 1) progressTimer = requestAnimationFrame(step);
      }
      progressTimer = requestAnimationFrame(step);
    }

    function startAuto() {
      animateProgress(controls[current]);
      timer = setInterval(function() {
        goTo(current + 1);
        animateProgress(controls[current]);
      }, speed);
    }

    function resetAuto() {
      clearInterval(timer);
      cancelAnimationFrame(progressTimer);
      resetProgress(controls[current]);
      startAuto();
    }

    var prevBtn = document.getElementById('hero-prev');
    var nextBtn = document.getElementById('hero-next');
    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); resetAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); resetAuto(); });

    controls.forEach(function(ctrl, i) {
      ctrl.addEventListener('click', function() { goTo(i); resetAuto(); });
    });

    if (total > 1) startAuto();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    var mainImg = document.getElementById('pdp-main-img');
    var mainWrap = document.getElementById('pdp-main-wrap');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.pdp__thumb'));
    var galleryPrev = document.getElementById('pdp-gallery-prev');
    var galleryNext = document.getElementById('pdp-gallery-next');
    var lightbox = document.getElementById('pdp-lightbox');
    var lightboxImg = document.getElementById('pdp-lightbox-img');
    var lightboxPrev = document.getElementById('pdp-lightbox-prev');
    var lightboxNext = document.getElementById('pdp-lightbox-next');

    function getActiveIndex() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function updateLightboxImage() {
      if (!lightboxImg) return;
      var src = getActiveImageSrc();
      if (!src) return;
      lightboxImg.src = src;
      lightboxImg.srcset = '';
      lightboxImg.removeAttribute('sizes');
    }

    function selectImageByIndex(index) {
      if (!thumbs.length) return;
      var nextIndex = (index + thumbs.length) % thumbs.length;
      var thumb = thumbs[nextIndex];
      var nextSrc = thumb.dataset.src;
      if (mainImg && nextSrc) {
        mainImg.style.opacity = '0';
        setTimeout(function() {
          mainImg.src = nextSrc;
          mainImg.srcset = '';
          mainImg.removeAttribute('sizes');
          mainImg.style.opacity = '1';
        }, 150);
      }
      if (mainWrap && nextSrc) {
        mainWrap.dataset.currentSrc = nextSrc;
      }
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (lightbox && lightbox.classList.contains('is-open')) {
        updateLightboxImage();
      }
    }

    function stepImage(delta) {
      selectImageByIndex(getActiveIndex() + delta);
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var index = thumbs.indexOf(thumb);
        if (index > -1) selectImageByIndex(index);
      });
    });

    function bindNavButton(button, delta) {
      if (!button) return;
      button.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        stepImage(delta);
      });
    }

    bindNavButton(galleryPrev, -1);
    bindNavButton(galleryNext, 1);
    bindNavButton(lightboxPrev, -1);
    bindNavButton(lightboxNext, 1);

    function getActiveImageSrc() {
      var activeThumb = document.querySelector('.pdp__thumb.is-active');
      if (activeThumb && activeThumb.dataset.src) {
        return activeThumb.dataset.src;
      }
      if (mainWrap && mainWrap.dataset.currentSrc) {
        return mainWrap.dataset.currentSrc;
      }
      if (mainImg) {
        return mainImg.currentSrc || mainImg.src;
      }
      return '';
    }

    function openLightbox() {
      if (!lightbox || !lightboxImg) return;
      updateLightboxImage();
      lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (mainWrap && lightbox && lightboxImg) {
      if (mainImg && mainImg.src) {
        mainWrap.dataset.currentSrc = mainImg.currentSrc || mainImg.src;
      }
      mainWrap.addEventListener('click', function(event) {
        if (event.target.closest('.pdp__gallery-nav')) return;
        openLightbox();
      });
      lightbox.addEventListener('click', function(event) {
        if (event.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', function(event) {
        if (!lightbox.classList.contains('is-open')) return;
        if (event.key === 'Escape') closeLightbox();
        if (event.key === 'ArrowLeft') stepImage(-1);
        if (event.key === 'ArrowRight') stepImage(1);
      });
    }

    // Product details tabs
    var pdpTabs = document.querySelectorAll('[data-pdp-tab]');
    var pdpPanels = document.querySelectorAll('.pdp-details__panel');
    pdpTabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var panelId = tab.getAttribute('data-pdp-tab');
        pdpTabs.forEach(function(item) {
          var isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        pdpPanels.forEach(function(panel) {
          var isActive = panel.id === panelId;
          panel.classList.toggle('is-active', isActive);
          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      });
    });

    // Product details tabs
    var pdpTabs = document.querySelectorAll('[data-pdp-tab]');
    var pdpPanels = document.querySelectorAll('.pdp-details__panel');
    pdpTabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var panelId = tab.getAttribute('data-pdp-tab');
        pdpTabs.forEach(function(item) {
          var isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        pdpPanels.forEach(function(panel) {
          var isActive = panel.id === panelId;
          panel.classList.toggle('is-active', isActive);
          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      });
    });

    // Qty stepper
    var qtyInput = document.getElementById('pdp-qty');
    var minus = document.getElementById('pdp-qty-minus');
    var plus = document.getElementById('pdp-qty-plus');
    if (qtyInput && minus && plus) {
      minus.addEventListener('click', function() {
        var v = parseInt(qtyInput.value, 10);
        if (v > 1) qtyInput.value = v - 1;
      });
      plus.addEventListener('click', function() {
        var current = parseInt(qtyInput.value, 10);
        var max = parseInt(qtyInput.max, 10);
        if (!isNaN(max) && max > 0 && current >= max) return;
        qtyInput.value = current + 1;
      });
    }

    // Variant switcher (option-based with colour swatches)
    var variantsJsonEl = document.getElementById('pdp-variants-json');
    if (variantsJsonEl) {
      var allVariants = JSON.parse(variantsJsonEl.textContent);
      var variantInput = document.getElementById('pdp-variant-id');
      var priceEl = document.querySelector('.pdp__price');
      var addBtn = document.getElementById('pdp-add-btn');
      var stockEl = document.getElementById('pdp-stock');
      var skuEl = document.getElementById('pdp-sku');
      var skuValEl = document.getElementById('pdp-sku-val');
      var colourValEl = document.getElementById('pdp-colour-val');

      var selectedOptions = [];
      var currentId = variantInput ? parseInt(variantInput.value, 10) : 0;
      for (var vi = 0; vi < allVariants.length; vi++) {
        if (allVariants[vi].id === currentId) { selectedOptions = allVariants[vi].options.slice(); break; }
      }
      if (!selectedOptions.length && allVariants.length) selectedOptions = allVariants[0].options.slice();

      function findVariant(opts) {
        for (var i = 0; i < allVariants.length; i++) {
          var v = allVariants[i]; var ok = true;
          for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
          if (ok) return v;
        }
        return null;
      }

      function applyVariant(variant) {
        if (!variant) return;
        if (variantInput) variantInput.value = variant.id;
        if (priceEl) priceEl.textContent = variant.price;
        var avail = variant.available;
        if (addBtn) { addBtn.disabled = !avail; addBtn.textContent = avail ? 'Add to cart' : 'Out of stock'; }
        var qtyWrap2 = document.getElementById('pdp-qty-wrap');
        if (qtyWrap2) qtyWrap2.style.display = avail ? '' : 'none';
        var actionsEl = document.querySelector('.pdp__actions');
        if (actionsEl) actionsEl.style.display = avail ? '' : 'none';
        var notifyWrap2 = document.getElementById('pdp-notify-wrap');
        var notifyBody2 = document.getElementById('pdp-notify-body');
        if (notifyWrap2) {
          notifyWrap2.style.display = avail ? 'none' : '';
          if (notifyBody2 && !avail) {
            var titleEl2 = document.querySelector('.pdp__title');
            var pName = titleEl2 ? titleEl2.textContent.trim() : '';
            notifyBody2.value = 'Back in stock request: ' + pName + ' — ' + selectedOptions.join(' / ') + ' (Variant ID: ' + variant.id + ')';
          }
        }
        if (stockEl) {
          if (avail) {
            if (variant.inventoryManagement === 'shopify' && variant.inventoryQuantity > 0 && variant.inventoryQuantity <= 5) {
              stockEl.className = 'pdp__stock pdp__stock--low'; stockEl.textContent = 'Only ' + variant.inventoryQuantity + ' left';
            } else { stockEl.className = 'pdp__stock pdp__stock--in'; stockEl.textContent = 'In stock'; }
            stockEl.style.display = '';
          } else { stockEl.style.display = 'none'; }
        }
        if (skuValEl) {
          var sku = variant.sku || ''; skuValEl.textContent = sku;
          if (skuEl) skuEl.style.display = sku ? '' : 'none';
        }
        if (qtyInput) {
          if (variant.inventoryManagement === 'shopify' && variant.inventoryQuantity > 0) {
            qtyInput.max = variant.inventoryQuantity;
            if (parseInt(qtyInput.value, 10) > variant.inventoryQuantity) qtyInput.value = variant.inventoryQuantity;
          } else { qtyInput.removeAttribute('max'); }
        }
        if (variant.imageIndex !== null && variant.imageIndex !== undefined && thumbs.length) {
          selectImageByIndex(variant.imageIndex);
        }
      }

      function handleOptionSelect(optIdx, value) {
        selectedOptions[optIdx] = value;
        document.querySelectorAll('[data-option="' + optIdx + '"]').forEach(function(el) {
          var isOn = el.dataset.value === value;
          el.classList.toggle('is-selected', isOn);
          el.setAttribute('aria-pressed', isOn ? 'true' : 'false');
        });
        if (colourValEl && document.querySelector('.pdp__swatch[data-option="' + optIdx + '"]')) {
          colourValEl.textContent = value;
        }
        var matched = findVariant(selectedOptions);
        if (matched) applyVariant(matched);
      }

      document.querySelectorAll('.pdp__variant-btn[data-option]').forEach(function(btn) {
        btn.addEventListener('click', function() { handleOptionSelect(parseInt(btn.dataset.option, 10), btn.dataset.value); });
      });
      document.querySelectorAll('.pdp__swatch').forEach(function(sw) {
        sw.addEventListener('click', function() { handleOptionSelect(parseInt(sw.dataset.option, 10), sw.dataset.value); });
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var carousel = document.getElementById('promo-carousel-{{ section.id }}');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('.promo-carousel__slide');
    var dots = carousel.querySelectorAll('.promo-carousel__dot');
    var prev = document.getElementById('promo-prev-{{ section.id }}');
    var next = document.getElementById('promo-next-{{ section.id }}');
    var current = 0;
    var total = slides.length;
    var timer = null;
    var speed = parseInt(carousel.dataset.autoplay || '6', 10) * 1000;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + total) % total;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function startAuto() {
      if (total < 2) return;
      timer = setInterval(function() { goTo(current + 1); }, speed);
    }

    function resetAuto() {
      clearInterval(timer);
      startAuto();
    }

    if (prev) prev.addEventListener('click', function(e) { e.preventDefault(); goTo(current - 1); resetAuto(); });
    if (next) next.addEventListener('click', function(e) { e.preventDefault(); goTo(current + 1); resetAuto(); });
    dots.forEach(function(dot) {
      dot.addEventListener('click', function(e) { e.preventDefault(); goTo(parseInt(dot.dataset.index, 10)); resetAuto(); });
    });

    startAuto();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function() {
    var sidebar = document.getElementById('search-sidebar');
    var overlay = document.getElementById('search-overlay');
    var openBtn = document.getElementById('search-filter-open');
    var closeBtn = document.getElementById('search-sidebar-close');

    function openSidebar() {
      if (sidebar) sidebar.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeSidebar() {
      if (sidebar) sidebar.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    if (openBtn) openBtn.addEventListener('click', openSidebar);
    if (closeBtn) closeBtn.addEventListener('click', closeSidebar);
    if (overlay) overlay.addEventListener('click', closeSidebar);

    document.querySelectorAll('.filter-group__btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var body = document.getElementById(btn.getAttribute('data-toggle'));
        if (!body) return;
        var open = body.classList.contains('is-open');
        body.classList.toggle('is-open', !open);
        btn.classList.toggle('is-open', !open);
        btn.setAttribute('aria-expanded', !open);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
